// Helper diagnostico Sentry/GlitchTip [sc-47917 F2B].
//
// Sostituisce l'errore lanciato "a mano" dalla Console come test di trasporto.
// Espone, SOLO quando VUE_APP_SENTRY_DIAGNOSTICS === "true", un helper applicativo:
//
//   window.__LT_SENTRY_DIAGNOSTICS__.captureTestError()
//
// che cattura un errore marcato via Sentry.captureException e ritorna l'eventId
// generato dall'SDK (mascherabile nei report).
//
// Vincoli: nessun auto-trigger, nessuna UI visibile, nessun dato utente/PII, nessun
// clientLog nel messaggio, un evento per chiamata. Assente se il flag non è "true".
import * as Sentry from "@sentry/vue";

const FLAG_KEY = "VUE_APP_SENTRY_DIAGNOSTICS";
const GLOBAL_KEY = "__LT_SENTRY_DIAGNOSTICS__";

function diagnosticsEnabled() {
  try {
    return String(process.env[FLAG_KEY] || "").toLowerCase() === "true";
  } catch {
    return false;
  }
}

// Cattura UN singolo errore di test e ritorna l'eventId (o null). Nessun dato sensibile:
// solo un marker temporale. Non lancia mai.
export function captureTestError() {
  try {
    const marker = `[SENTRY TUNNEL SMOKE ${new Date().toISOString()}]`;
    return Sentry.captureException(new Error(marker)) || null;
  } catch {
    return null;
  }
}

// Installa l'helper su window SOLO se il flag è attivo. Idempotente e no-op altrimenti.
// Ritorna true se installato, false se non installato (flag off o niente window).
export function installSentryDiagnostics() {
  try {
    if (!diagnosticsEnabled()) return false;
    if (typeof window === "undefined") return false;
    window[GLOBAL_KEY] = { captureTestError };
    return true;
  } catch {
    return false;
  }
}

export default { installSentryDiagnostics, captureTestError };
